import { OnInit, OnDestroy, Component, Inject, Optional, ElementRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { NxiRestService } from '../../../services/NXI-Rest.service';
import { PershingTranslationService } from '@pershing/pershing-core';
import { AWRContextUtils, AwrDomainContext, AWRContextService } from '@pershing/nxi-core';
declare let dojoApp: any;

@Component({
    selector: 'dojo-awr-tab-container',
    templateUrl: './awr-tab-container.component.html'
})
export class DojoAwrTabContainerComponent implements OnInit, OnDestroy {
    inputValue: string = '';
    domain: string = '';
    subs: Subscription;
    goToTab: string;
    timePeriod: string;
    fullEnabled: boolean;
    thresholdLimitExceeded: boolean;
    thresholdLimit: any;
    liteEnabled: boolean;
    isPortfolioPlusEntitled: boolean;
    isAggregationEnabled: boolean;
    isGroupAccount: boolean;
    appSettings: any;
    isADA: boolean;
    isMobile: boolean;
    acctRef: any;

    constructor(
        private awrContextService: AWRContextService,
        private nxiRestService: NxiRestService, @Optional() @Inject('AppSettings') appSettings: any, private translationService: PershingTranslationService,
        private elRef: ElementRef ) {
            if (appSettings.themeType === 'ada') {
                this.isADA = true;
            }
            if (appSettings.deviceType === 'mobile') {
                this.isMobile = true;
            }
            this.translationService.addTranslationFolder('@pershing/nxi-ng-portfolio', 'node_modules/@pershing/nxi-ng-portfolio/lib');
    }

    ngOnInit() {
        // if (window['require']) {
        //     let topic = window['require']('dojo/topic');
        //     topic.subscribe('/nxi/awr/account', accountObj => {
        //         this.acctRef = accountObj.account;
        //         this.getAwrTabContainer();
        //     });
        // }

         this.subs = this.awrContextService.selectedAwrDomainContext$.subscribe((awrDomainContext: AwrDomainContext<any>) => {
             let contextValue = AWRContextUtils.getContextFromDomainValue(awrDomainContext);
             this.acctRef = contextValue.accountNumber;
             this.goToTab = contextValue.goToTab;
             this.timePeriod = contextValue.timePeriod;
             this.getAwrTabContainer();
         });

         if (window['require']) {
            let topic = window['require']('dojo/topic');
            topic.subscribe('isGroupAccount', value => {
                let element = document.getElementById('p_p_id_AWRTabContainer_WAR_netxinvestorportfolio_awrPerformanceSummary');
                console.log('element ' + element);
                if (value) {
                    this.isGroupAccount = true;
                    if (element) {
                        element.classList.remove('dijitDisplayNone');
                    }
                } else {
                    this.isGroupAccount = false;
                    if (element) {
                        element.classList.add('dijitDisplayNone');
                    }
              }
        });
    }
}

    ngOnDestroy(): void {
        if (this.subs) {
            this.subs.unsubscribe();
        }
        if (dojoApp) {
            // pass necessary parameters to render dojo widgets
            dojoApp.destroyAwrTabContainer();
        }
    }
    renderDojoWidget(awrTabContainerDojoParams: any) {
        if (dojoApp) {
            // pass necessary parameters to render dojo widgets
            if (this.isADA) {
                dojoApp.renderAwrForADA(awrTabContainerDojoParams);
            } else {
                dojoApp.renderAwrTabContainer(awrTabContainerDojoParams);
            }
            if (this.isMobile) {
                awrTabContainerDojoParams.goToTab = this.goToTab;
                dojoApp.renderAWRNavForMobile(awrTabContainerDojoParams);
            }

        }
    }
    getAwrTabContainer() {
        if (this.acctRef !== '') {
            this.nxiRestService.getNxiPortfolioRestResponse(this.acctRef, 'awrTabContainer').subscribe(
                resp => {
                    let paramResponse: any = resp.response;
                    console.log('Retrived Portfolio AWR Tab params : ', paramResponse);
                    if (paramResponse && paramResponse.acctRef) {
                        paramResponse.acctSummaryUrl = this.nxiRestService.serviceUrl + this.getFormattedURL(paramResponse, 'acctSummaryUrl');
                        paramResponse.valuationOverTimeUrlTemplate = this.nxiRestService.serviceUrl + this.getFormattedURL(paramResponse, 'valuationOverTimeUrlTemplate');
                        paramResponse.performanceChartUrl = this.nxiRestService.serviceUrl + this.getFormattedURL(paramResponse, 'performanceChartUrl');
                        paramResponse.assetClassPerfUrl = this.nxiRestService.serviceUrl + this.getFormattedURL(paramResponse, 'assetClassPerfUrl');
                        paramResponse.compositionUrlTemplate = this.nxiRestService.serviceUrl + this.getFormattedURL(paramResponse, 'compositionUrlTemplate');
                        paramResponse.holdingsPerfUrlTemplate = this.nxiRestService.serviceUrl + this.getFormattedURL(paramResponse, 'holdingsPerfUrlTemplate');
                        paramResponse.intraDayAcctsURL = this.nxiRestService.serviceUrl + paramResponse.intraDayAcctsURL;
                        paramResponse.mstarJwtTokenUrl = this.nxiRestService.serviceUrl + paramResponse.mstarJwtTokenUrl;
                        paramResponse.ifaupdateUrl = this.nxiRestService.serviceUrl + paramResponse.ifaupdateUrl;
                        paramResponse.currentTab = this.goToTab;
                        paramResponse.timePeriod = this.timePeriod;
                        this.fullEnabled = paramResponse.fullEnabled;
                        this.thresholdLimitExceeded = paramResponse.thresholdLimitExceeded;
                        this.thresholdLimit = paramResponse.thresholdLimit;
                        this.liteEnabled = paramResponse.liteEnabled;
                        paramResponse.groupAccount = this.isGroupAccount;
                        paramResponse.isGroupAccount = this.isGroupAccount;
                        // this.isGroupAccount = paramResponse.groupAccount;
                        this.isPortfolioPlusEntitled = paramResponse.isPortfolioPlusEntitled;
                        this.isAggregationEnabled = paramResponse.isAggregationEnabled;
                        this.renderDojoWidget(paramResponse);
                    }
                }
            );
        }
    }
    getFormattedURL(paramResponse: any, URL: any) {
        let summaryURL = '';
        if (!!this.acctRef) {
            // if (!paramResponse.pershingAccountRef) {
            //     paramResponse.acctRef = this.acctRef;
            // } else {
            //     paramResponse.pershingAccountRef = paramResponse.acctRef;
            // }
            let summaryURLArray = paramResponse[URL].split('/');
            if (summaryURLArray.length > 0) {
               // if (!paramResponse.pershingAccountRef) {
                    summaryURLArray[2] = this.acctRef;
                // }
                // } else {
                //     summaryURLArray[2] = paramResponse.acctRef;
                // }
            }
            let connector = '';
            summaryURLArray.forEach(element => {
                if (element !== '') {
                    connector = '/';
                }
                summaryURL = summaryURL + connector + element;
            });
        }
        if (summaryURL !== '') {
            paramResponse[URL] = summaryURL;
        }
        return paramResponse[URL];
    }
    expandAll() {
        if (window['require']) {
            let topic = window['require']('dojo/topic');
            topic.publish('/awr/awrHoldings/expandAll', {expandAll : true});
        }
    }
    collapseAll() {
        if (window['require']) {
            let topic = window['require']('dojo/topic');
            topic.publish('/awr/awrHoldings/collapseAll', {expandAll : false});
        }
    }
    gotoTop() {
        window.scroll({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });
    }
}
